import type { Component } from "solid-js";
import { createMemo, Show } from "solid-js";
import type { RouteSectionProps } from "@solidjs/router";
import { Title } from "@solidjs/meta";
import InviteService from "../../services/InviteService";
import { useTranslation } from "../../state/i18n";
import { QueryBoundary } from "../../utils/QueryBoundary";
import GlobalLoadingPage from "../GlobalLoadingPage";
import InviteAcceptanceNewUserState from "./InviteAcceptanceNewUserState";
import InviteAcceptanceExistingUserState from "./InviteAcceptanceExistingUserState";
import InviteAcceptanceErrorState from "./InviteAcceptanceErrorState";

const InviteAcceptancePage: Component<RouteSectionProps<never>> = (props) => {
  const { t } = useTranslation();
  const token = createMemo(() => props.params.inviteToken);
  const inviteQuery = createMemo(() => InviteService.getInvite(token() ?? ""));

  return (
    <>
      <Title>{t(($) => $.INVITE_PAGE_PAGE_TITLE)}</Title>
      <Show when={token()} fallback={<InviteAcceptanceErrorState />}>
        {(resolvedToken) => (
          <QueryBoundary
            loadingFallback={<GlobalLoadingPage text={t(($) => $.INVITE_PAGE_LOADING_TEXT)} />}
            errorFallback={<InviteAcceptanceErrorState />}
          >
            <Show when={inviteQuery().data}>
              {(invite) => (
                <Show
                  when={invite().status === "EXISTING_USER"}
                  fallback={<InviteAcceptanceNewUserState invite={invite()} token={resolvedToken()} />}
                >
                  <InviteAcceptanceExistingUserState invite={invite()} token={resolvedToken()} />
                </Show>
              )}
            </Show>
          </QueryBoundary>
        )}
      </Show>
    </>
  );
};

export default InviteAcceptancePage;
